<template>
  <div class="p-1 w-100 d-flex justify-content-center">
    <b-form-group class="mb-0">
      <b-row class="artwork-details-cols flex-nowrap" name="artwork-details-cols">
        <b-col>
          <ul class="clean-list">
            <li>Dimensions:</li>
            <li>Resolution:</li>
            <li>Colour space:</li>
            <li>Format:</li>
            <li>File size:</li>
          </ul>
        </b-col>
        <b-col>
          <ul class="clean-list">
            <li>{{ details.width }} x {{ details.height }}</li>
            <li>{{ details.density }} ({{ details.density_unit }})</li>
            <li>{{ details.colour_space }}</li>
            <li>{{ details.format }}</li>
            <li>{{ formatBytesAs(details.file_size, `MB`) }}</li>
          </ul>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
